import React, { useState } from 'react';

import QuoterContext from './context/QuoterContext';

import NavbarContainer from './containers/NavbarContainer';
import StepLoader from './components/StepLoader';
import QuoterContainer from './containers/QuoterContainer';
import QuoterHeader from './components/QuoterHeader';
import QuoterProgress from './components/QuoterProgress';
import FooterContainer from './containers/FooterContainer';

import { APP_INITIAL_VALUES } from './constants/initialValues';

function App() {
  const [quoterContextValues, setQuoterContextValues] = useState(APP_INITIAL_VALUES);
  const appClassNames = quoterContextValues.isAppLoading ? '-loading' : '';

  return (
    <QuoterContext.Provider value={{ quoterContextValues, setQuoterContextValues }}>
      <div className={`main-app ${appClassNames}`}>
        <StepLoader isAppLoading={quoterContextValues.isAppLoading} />
        <NavbarContainer />
        <QuoterHeader />
        <QuoterProgress />
        <QuoterContainer />
        <FooterContainer />
      </div>
    </QuoterContext.Provider>
  );
}

export default App;
